import series from '../../data/series-info.json';

export const useSeriesData = () => {
  return series;
};
